// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../img/empty.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../img/sort_asc.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../img/sort_desc.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../img/check.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sort-block {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: start;
    width: 100%;
}

.sort-block__item {
    cursor: pointer;
    display: flex;
    flex-direction: row;
    /*align-items: center;*/
    font-size: 0.8em;
    margin-right: 10px;
    text-decoration: none !important;
    outline: none !important;
    color: var(--color-granite) !important;
}

.sort-block__item:before {
    display: none;
}

.sort-block__item:after {
    flex: 0 0 auto;
    height: 1.4em;
    width: 1.4em;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    content: '';
}

.sort-block__item > span {
    display: inline-block;
    padding-left: 0;
    text-decoration: underline;
    white-space: nowrap;
    padding-right: 2px;
}

.sort-block__item:before,
.sort-block__item:after {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.sort-block__item.asc:before,
.sort-block__item.asc:after {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.sort-block__item.desc:before,
.sort-block__item.desc:after {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

.sort-block__item.active:before,
.sort-block__item.active:after {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

.sort-block__item.empty:before,
.sort-block__item.empty:after {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

@media screen and (max-width: 1024px) {

    .sort-block {
        display: block;
    }

    .sort-block__item {
        display: flex;
        flex-direction: row;
        font-size: 1em;
        padding: 5px 15px 5px 15px;
        align-items: center;
    }

    .sort-block__item:before {
        display: inline-block;
        flex: 0 0 auto;
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        content: '';
        height: 24px;
        width: 24px;
    }

    .sort-block__item:after {
        display: none;
    }

    .sort-block__item > span {
        display: inline-block;
        padding-right: 0;
        text-decoration: underline;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        padding-left: 10px;
    }

}
`, "",{"version":3,"sources":["webpack://./resources/assets/site/css/sort.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,kBAAkB;IAClB,gCAAgC;IAChC,wBAAwB;IACxB,sCAAsC;AAC1C;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,YAAY;IACZ,sBAAsB;IACtB,2BAA2B;IAC3B,4BAA4B;IAC5B,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,0BAA0B;IAC1B,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;;IAEI,yDAAuC;AAC3C;;AAEA;;IAEI,yDAA0C;AAC9C;;AAEA;;IAEI,yDAA2C;AAC/C;;AAEA;;IAEI,yDAAuC;AAC3C;;AAEA;;IAEI,yDAAuC;AAC3C;;AAEA;;IAEI;QACI,cAAc;IAClB;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,cAAc;QACd,0BAA0B;QAC1B,mBAAmB;IACvB;;IAEA;QACI,qBAAqB;QACrB,cAAc;QACd,sBAAsB;QACtB,2BAA2B;QAC3B,4BAA4B;QAC5B,WAAW;QACX,YAAY;QACZ,WAAW;IACf;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,qBAAqB;QACrB,gBAAgB;QAChB,0BAA0B;QAC1B,mBAAmB;QACnB,gBAAgB;QAChB,uBAAuB;QACvB,kBAAkB;IACtB;;AAEJ","sourcesContent":[".sort-block {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: start;\n    width: 100%;\n}\n\n.sort-block__item {\n    cursor: pointer;\n    display: flex;\n    flex-direction: row;\n    /*align-items: center;*/\n    font-size: 0.8em;\n    margin-right: 10px;\n    text-decoration: none !important;\n    outline: none !important;\n    color: var(--color-granite) !important;\n}\n\n.sort-block__item:before {\n    display: none;\n}\n\n.sort-block__item:after {\n    flex: 0 0 auto;\n    height: 1.4em;\n    width: 1.4em;\n    background-size: cover;\n    background-position: center;\n    background-repeat: no-repeat;\n    content: '';\n}\n\n.sort-block__item > span {\n    display: inline-block;\n    padding-left: 0;\n    text-decoration: underline;\n    white-space: nowrap;\n    padding-right: 2px;\n}\n\n.sort-block__item:before,\n.sort-block__item:after {\n    background-image: url(../img/empty.svg);\n}\n\n.sort-block__item.asc:before,\n.sort-block__item.asc:after {\n    background-image: url(../img/sort_asc.svg);\n}\n\n.sort-block__item.desc:before,\n.sort-block__item.desc:after {\n    background-image: url(../img/sort_desc.svg);\n}\n\n.sort-block__item.active:before,\n.sort-block__item.active:after {\n    background-image: url(../img/check.svg);\n}\n\n.sort-block__item.empty:before,\n.sort-block__item.empty:after {\n    background-image: url(../img/empty.svg);\n}\n\n@media screen and (max-width: 1024px) {\n\n    .sort-block {\n        display: block;\n    }\n\n    .sort-block__item {\n        display: flex;\n        flex-direction: row;\n        font-size: 1em;\n        padding: 5px 15px 5px 15px;\n        align-items: center;\n    }\n\n    .sort-block__item:before {\n        display: inline-block;\n        flex: 0 0 auto;\n        background-size: cover;\n        background-position: center;\n        background-repeat: no-repeat;\n        content: '';\n        height: 24px;\n        width: 24px;\n    }\n\n    .sort-block__item:after {\n        display: none;\n    }\n\n    .sort-block__item > span {\n        display: inline-block;\n        padding-right: 0;\n        text-decoration: underline;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        padding-left: 10px;\n    }\n\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
